import {Component, inject, OnInit} from '@angular/core';
import {RouterLink} from "@angular/router";
import {DataService} from "../../../services/data.service";

@Component({
    selector: 'app-product-group-list',
    imports: [RouterLink],
    template: `
        <div class="card">
            <div class="card-body">
                <div class="mb-4">
                    <h3><i class="fa-solid fa-box me-2"></i>Produktgruppen <small class="text-muted">({{totalEntries}})</small></h3>
                </div>

                <button type="button" class="btn btn-primary mb-3" [routerLink]="['/productgroup', 0]">Produktgruppe anlegen</button>

                @if (entries?.length > 0) {
                    <div class="table-responsive">
                        <table class="table table-striped table-hover mb-0 pointer">
                            <thead>
                            <tr>
                                <th style="width: 200px" (click)="setOrder('position')">
                                    Nummer
                                    @if (predicate == 'position') {
                                        <i class="fa-solid" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                                    }
                                </th>
                                <th (click)="setOrder('name')">
                                    Name
                                    @if (predicate == 'name') {
                                        <i class="fa-solid" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                                    }
                                </th>
                                <th (click)="setOrder('products')" style="width: 200px">
                                    # Produkte
                                    @if (predicate == 'products') {
                                        <i class="fa-solid" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                                    }
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            @for (entry of entries; track entry.id) {
                                <tr [routerLink]="['/productgroup', entry.id]">
                                    <td>{{ entry.position }}</td>
                                    <td>{{ entry.name }}</td>
                                    <td>{{ entry.products }}</td>
                                </tr>
                            }
                            </tbody>
                        </table>
                    </div>
                }
            </div>
        </div>
    `
})
export class ProductGroupListComponent implements OnInit {

    private dataService = inject(DataService);

    paginConfig: any = {
        itemsPerPage: 25,
        page: 1
    };
    entries!: any[] | null;
    totalEntries = 0;
    predicate = 'position';
    search: any = {
        text: ''
    };
    reverse = false;

    ngOnInit(): void {
        this.listEntries(this.paginConfig);
    }

    setOrder(order: string): void {
        this.predicate = order;
        this.reverse = !this.reverse;
        this.paginConfig.page = 1;
        this.listEntries(this.paginConfig);
    }

    checkFilterAndList(): void {
        this.paginConfig.page = 1;
        this.listEntries(this.paginConfig);
    }

    listEntries(event: any): void {
        this.paginConfig = event;

        this.entries = null;
        this.dataService.request('ProductGroup/listAll', {
            page: this.paginConfig.page,
            limit: this.paginConfig.itemsPerPage,
            order: this.predicate,
            reverse: this.reverse,
            filter: this.search.text,
        }).subscribe(response => {
            this.totalEntries = response.total;
            this.entries = response.productGroups;
        });
    }
}
